export default "__VITE_ASSET__DA4pevJz__$_?imageSize__"